import React from 'react';
import PropTypes from 'prop-types';

export function SvgAreaZoom(props) {
  const { width = 16, height = 16, stroke = '#000' } = props;

  return (
    <svg xmlns="http://www.w3.org/2000/svg" width={width} height={height} viewBox="0 0 16 16">
      <g fill="none" fillRule="evenodd" stroke="none" strokeWidth="1">
        <path
          fill={stroke}
          d="M15 10.667v2c0 1.235-.96 2.246-2.174 2.328l-.16.005h-2v-2h2a.333.333 0 00.327-.266l.007-.067v-2h2zm-12 0v2c0 .16.114.295.266.326l.067.007h2v2h-2a2.333 2.333 0 01-2.328-2.174L1 12.666v-2h2zM5.333 1v2h-2a.333.333 0 00-.326.266L3 3.333v2H1v-2c0-1.235.96-2.246 2.174-2.328L3.334 1h2zm7.334 0c1.235 0 2.246.96 2.328 2.174l.005.16v2h-2v-2a.333.333 0 00-.266-.327L12.667 3h-2V1h2z"
        />
      </g>
    </svg>
  );
}

SvgAreaZoom.propTypes = {
  width: PropTypes.string,
  height: PropTypes.string,
  stroke: PropTypes.string,
};
